export default {
  "config": {
    "trial": "tones-3",
    "id": "aes-teaes",
    "type": "table",
    "title": "Incidence of Adverse Events in All Treatment Groups<sup>23</sup>",
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
      "*Most common adverse events were those reported as <no-break>≥5%</no-break> in any treatment group."
    ],
    "useFootnoteTooltip": false
  },
  "data": {
    "trial": "tones-3",
    "id": "aes-teaes",
    "data-type": "table",
    "title": "Incidence of Adverse Events in All Treatment Groups<sup>23</sup>",
    "num-header-rows": 2,
    "num-columns": 7,
    "col-classes": [
      "col-1",
      "pbo",
      "sol",
      "sol",
      "sol",
      "sol",
      "sol"
    ],
    "row-mergeoption": [
      1,
      2,
      6
    ],
    "footnote-tooltip": "disable",
    "footnote-order": [
      "footnote-note1",
      "footnote-note2"
    ],
    "footnote-note1": "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
    "footnote-note2": "*Most common adverse events were those reported as <no-break>≥5%</no-break> in any treatment group.",
    "data": {
      "row-0": [
        {
          "content": null,
          "cols": 2,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<center><b>Solriamfetol</b></center>",
          "cols": 5,
          "class": "sol"
        }
      ],
      "row-1": [
        {
          "indent": 0,
          "content": "<b>Adverse event</b>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<b>Placebo<br><no-break>(n = 119)</no-break></b>",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<b><no-break>37.5 mg</no-break><br><no-break>(n = 58)</no-break></b>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<b><no-break>75 mg</no-break><br><no-break>(n = 62)</no-break></b>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<b><no-break>150 mg</no-break><br><no-break>(n = 117)</no-break></b>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<b><no-break>300 mg</no-break><br><no-break>(n  = 118)</no-break></b>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<b>Combined<br><no-break>(n = 355)</no-break></b>",
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-2": [
        {
          "indent": 0,
          "content": "Any adverse event, <no-break>n (%)</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "57 (47.9)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "37 (63.8)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "30 (48.4)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "83 (70.9)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "91 (77.1)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "241 (67.9)",
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-3": [
        {
          "indent": 0,
          "content": "Serious adverse event, <no-break>n (%)</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "2 (1.7)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "2 (3.4)",
          "cols": 1,
          "class": "sol"
        },
        {
          "content": 0,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "1 (0.9)",
          "cols": 1,
          "class": "sol"
        },
        {
          "content": 0,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "3 (0.8)",
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-4": [
        {
          "indent": 0,
          "content": "Adverse event leading to study drug discontinuation, <no-break>n (%)</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "4 (3.4)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "3 (5.2)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "2 (3.2)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "5 (4.3)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "16 (13.6)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "26 (7.3)",
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-5": [
        {
          "indent": 0,
          "content": "Most common adverse events,* <no-break>n (%)</no-break>",
          "cols": 7,
          "class": "col-1",
          "parentRow": true,
          "parent": 5
        }
      ],
      "row-6": [
        {
          "indent": 1,
          "parent": 5,
          "content": "Headache",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "10 (8.4)",
          "parent": 5,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "4 (6.9)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "5 (8.1)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "10 (8.5)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "17 (14.4)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "36 (10.1)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-7": [
        {
          "indent": 1,
          "parent": 5,
          "content": "Nausea",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "7 (5.9)",
          "parent": 5,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "3 (5.2)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "3 (4.8)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "10 (8.5)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "12 (10.2)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "28 (7.9)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-8": [
        {
          "indent": 1,
          "parent": 5,
          "content": "Decreased appetite",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "1 (0.8)",
          "parent": 5,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "1 (1.7)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "3 (4.8)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "9 (7.7)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "14 (11.9)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "27 (7.6)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-9": [
        {
          "indent": 1,
          "parent": 5,
          "content": "Anxiety",
          "cols": 1,
          "class": "col-1"
        },
        {
          "content": 0,
          "parent": 5,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "1 (1.7)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "2 (3.2)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "6 (5.1)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "16 (13.6)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "25 (7.0)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-10": [
        {
          "indent": 1,
          "parent": 5,
          "content": "Nasopharyngitis",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "8 (6.7)",
          "parent": 5,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "2 (3.4)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "1 (1.6)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "7 (6.0)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "8 (6.8)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "18 (5.1)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-11": [
        {
          "indent": 1,
          "parent": 5,
          "content": "Diarrhea",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "1 (0.8)",
          "parent": 5,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "1 (1.7)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "3 (4.8)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "5 (4.3)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "8 (6.8)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "17 (4.8)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-12": [
        {
          "indent": 1,
          "parent": 5,
          "content": "Dry mouth",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "2 (1.7)",
          "parent": 5,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "1 (1.7)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "1 (1.6)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "5 (4.3)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "9 (7.6)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "16 (4.5)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-13": [
        {
          "indent": 1,
          "parent": 5,
          "content": "Insomnia",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "2 (1.7)",
          "parent": 5,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "1 (1.7)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "content": 0,
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "3 (2.6)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "11 (9.3)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "15 (4.2)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-14": [
        {
          "indent": 1,
          "parent": 5,
          "content": "Feeling jittery",
          "cols": 1,
          "class": "col-1"
        },
        {
          "content": 0,
          "parent": 5,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "3 (5.2)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "3 (4.8)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "1 (0.9)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "7 (5.9)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "14 (3.9)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-15": [
        {
          "indent": 1,
          "parent": 5,
          "content": "Sinusitis",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "3 (2.5)",
          "parent": 5,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "1 (1.7)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "4 (6.5)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "content": 0,
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "3 (2.5)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "8 (2.3)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-16": [
        {
          "indent": 1,
          "parent": 5,
          "content": "Irritability",
          "cols": 1,
          "class": "col-1"
        },
        {
          "content": 0,
          "parent": 5,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "3 (5.2)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "content": 0,
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "4 (3.4)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "1 (0.8)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "8 (2.3)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-17": [
        {
          "indent": 1,
          "parent": 5,
          "content": "Pruritus",
          "cols": 1,
          "class": "col-1"
        },
        {
          "content": 0,
          "parent": 5,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "3 (5.2)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "content": 0,
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "1 (0.9)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "content": 0,
          "parent": 5,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "4 (1.1)",
          "parent": 5,
          "cols": 1,
          "class": "sol"
        }
      ]
    }
  }
};